import React from 'react';

export default function Header() {
  return (
    <div className="text-center mb-4">
      <h1 className="header-title">RETAIL AI</h1>
      <p className="header-sub">Empowering Retail with Artificial Intelligence</p>
    </div>
  );
}